import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import * as actions from './actions';

type MuxDetails = {
  microphoneError: string | null;
  token: string;
  isBroadcasting: boolean;
  preferredAudioOutput: string;
  isChangePermissionRequested: boolean;
  isBusy: boolean;
};

const initialState: MuxDetails = {
  token: '',
  isChangePermissionRequested: false,
  microphoneError: null,
  isBroadcasting: false,
  preferredAudioOutput: 'default',
  isBusy: false,
};

export const muxDetails = createSlice({
  name: 'mux-details',
  initialState,
  reducers: {
    setMicrophoneError: (state, action: PayloadAction<MuxDetails['microphoneError']>) => {
      state.microphoneError = action.payload;
    },
    setIsBroadcasting: (state, action: PayloadAction<MuxDetails['isBroadcasting']>) => {
      state.isBroadcasting = action.payload;
    },
    setIsChangePermissionRequested: (state, action: PayloadAction<MuxDetails['isChangePermissionRequested']>) => {
      state.isChangePermissionRequested = action.payload;
    },
    setPreferredAudioOutput: (state, action: PayloadAction<MuxDetails['preferredAudioOutput']>) => {
      state.preferredAudioOutput = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actions.startBroadcast.pending, (state) => {
        state.isBusy = true;
      })
      .addCase(actions.startBroadcast.fulfilled, (state) => {
        state.isBusy = false;
      })
      .addCase(actions.startBroadcast.rejected, (state) => {
        state.isBusy = false;
      })
      .addCase(actions.stopBroadcast.pending, (state) => {
        state.isBusy = true;
      })
      .addCase(actions.stopBroadcast.fulfilled, (state) => {
        state.isBusy = false;
      })
      .addCase(actions.stopBroadcast.rejected, (state) => {
        state.isBusy = false;
      })
      .addCase(actions.getToken.pending, (state) => {
        state.isBusy = true;
      })
      .addCase(actions.getToken.fulfilled, (state, action) => {
        state.isBusy = false;

        if (action.payload.success) {
          state.token = action.payload.token;
        }
      })
      .addCase(actions.getToken.rejected, (state) => {
        state.isBusy = false;
      })
      .addCase(actions.updatePermissions.pending, (state) => {
        state.isBusy = true;
      })
      .addCase(actions.updatePermissions.fulfilled, (state) => {
        state.isBusy = false;
        state.isChangePermissionRequested = false;
      })
      .addCase(actions.updatePermissions.rejected, (state) => {
        state.isBusy = false;
        state.isChangePermissionRequested = false;
      });
  },
});

export const { setMicrophoneError, setIsChangePermissionRequested, setPreferredAudioOutput, setIsBroadcasting } =
  muxDetails.actions;
export default muxDetails.reducer;
